<template>
    <div class="zebra-crossing-detail">
        <el-form>
            <div class="zebra-item">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户名:">{{detail.userid}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="中文名:">{{detail.name}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="性别:">{{detail.gender==1?'男':'女'}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号:">{{detail.mobile}}</el-form-item>
                    </el-col>


                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="编号:">{{detail.employeeNo}}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮箱:">{{detail.email}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>


                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    import services from './system.service'
    export default {
        name: "onlineUserView",
        props:{
            internalUserid:String
        },
        data(){
            return{
                detail:{}
            }
        },
        created(){
            this.getDetail()
        },
        methods:{
            getDetail(){
                services.getOnlineUsersDetail({internalUserid:this.internalUserid}).then(res=>{
                    // console.log(res);
                    this.detail=res
                })
            }
        },
    }
</script>

<style scoped>

</style>
